/**
 * The types of data that is supported.
 */
export enum DataType {
    Xml = "Xml",
    Json = "Json",
    Tabular = "Tabular"
}